var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-center table-edit-icon",on:{"click":function($event){return _vm.addSubCategory()}}},[_c('i',{staticClass:"text-center material-icons"},[_vm._v("remove_red_eye")])])])}
var staticRenderFns = []

export { render, staticRenderFns }